"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_1 = __importDefault(require("lodash"));
// This returns a function which when called will loop through all of the rules passed and return the first non-falsy (i.e. error message string) value returned
const createRuleIterator = (rules) => (fieldValue, formValues) => (0, lodash_1.default)(rules)
    .filter(lodash_1.default.isFunction)
    .map((rule) => rule(fieldValue, formValues))
    .compact()
    .head();
const createValidator = (schema, step) => (formValues = {}) => {
    const messages = {};
    (0, lodash_1.default)(schema)
        .pickBy((definition) => {
        if (lodash_1.default.isEmpty(step))
            return true;
        if (lodash_1.default.isPlainObject(definition) && lodash_1.default.isArray(definition.step))
            return lodash_1.default.includes(definition.step, step);
        return definition.step === step;
    })
        .keys()
        .forEach((fieldName) => {
        function processRules(ruleSet) {
            const rule = createRuleIterator([].concat(ruleSet)); // concat enables both functions and arrays of functions
            // The result of running the joined rule function will either be:
            // - string: an error
            // - array of functions: more validations to run
            // - undefined: indicating no error
            const ruleResult = rule(formValues[fieldName], formValues);
            if (ruleResult) {
                if (lodash_1.default.isArray(ruleResult)) {
                    processRules(ruleResult);
                }
                else {
                    messages[fieldName] = ruleResult;
                }
            }
        }
        processRules(schema[fieldName].validation);
    });
    return messages;
};
exports.default = createValidator;
